// src/Components/Navbar.js
import React, { useState } from 'react';

const Navbar = ({ setCurrentPage, currentPage }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleNavLinkClick = (page) => {
    setCurrentPage(page);
    setIsMenuOpen(false); // Close menu on navigation click
  };

  return (
    <nav className="bg-gradient-to-r from-blue-900 to-blue-700 shadow-xl sticky top-0 z-50">
      <div className="container mx-auto flex flex-wrap justify-between items-center">
        <div className="text-white text-3xl font-extrabold tracking-wide rounded-lg transition-transform duration-300 hover:scale-105 cursor-pointer"><a class="navbar-brand" href="/"><img alt="Celerity Technocrats" className='logo' src="images/CelerityWhiteLogo.png" /></a>
        </div>

        {/* Hamburger menu icon for mobile */}
        <div className="md:hidden flex items-center">
          <button onClick={toggleMenu} className="text-white focus:outline-none focus:ring-2 focus:ring-white p-2 rounded-md">
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="[http://www.w3.org/2000/svg](http://www.w3.org/2000/svg)">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d={isMenuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"}></path>
            </svg>
          </button>
        </div>

        {/* Desktop navigation links */}
        <div className="hidden md:flex space-x-4 md:space-x-6">
          {['home', 'services', 'portfolio', 'about', 'team', 'contact'].map((page) => (
            <button
              key={page}
              onClick={() => handleNavLinkClick(page)}
              className={`px-3 py-1 md:px-4 md:py-2 rounded-full text-base md:text-lg font-medium transition-all duration-300 ease-in-out
                ${currentPage === page
                  ? 'bg-white text-blue-700 shadow-lg transform scale-105 border border-blue-700'
                  : 'text-white hover:bg-blue-500 hover:text-white hover:shadow-md hover:brightness-110'
                }`}
            >
              {page.charAt(0).toUpperCase() + page.slice(1)}
            </button>
          ))}
        </div>
      </div>

      {/* Mobile menu (conditionally rendered) */}
      {isMenuOpen && (
        <div className="md:hidden mt-4 bg-blue-700 rounded-lg shadow-lg py-2">
          {['home', 'services', 'portfolio', 'about', 'team', 'contact'].map((page) => (
            <button
              key={page}
              onClick={() => handleNavLinkClick(page)}
              className="block w-full text-left px-5 py-3 text-white text-lg hover:bg-blue-600 transition-colors duration-200"
            >
              {page.charAt(0).toUpperCase() + page.slice(1)}
            </button>
          ))}
        </div>
      )}
    </nav>
  );
};

export default Navbar;
// // src/Components/Navbar.js
// import React from 'react';

// const Navbar = ({ setCurrentPage, currentPage }) => {
//   return (
//     <nav className="bg-gradient-to-r from-blue-900 to-blue-700 p-4 shadow-xl sticky top-0 z-50">
//       <div className="container mx-auto flex flex-wrap justify-between items-center">
//         <div className="text-white text-3xl font-extrabold tracking-wide rounded-lg transition-transform duration-300 hover:scale-105 cursor-pointer">
//         <a class="navbar-brand" href="/"><img alt="Celerity Technocrats" className='logo' src="images/CelerityLogoT2.png" /></a>
//         </div>
//         <div className="flex space-x-4 md:space-x-6">
//           {['home', 'services', 'about', 'team', 'contact'].map((page) => (
//             <button
//               key={page}
//               onClick={() => setCurrentPage(page)}
//               className={`px-3 py-1 md:px-4 md:py-2 rounded-full text-base md:text-lg font-medium transition-all duration-300 ease-in-out
//                 ${currentPage === page
//                   ? 'bg-white text-blue-700 shadow-lg transform scale-105 border border-blue-700'
//                   : 'text-white hover:bg-blue-500 hover:text-white hover:shadow-md hover:brightness-110'
//                 }`}
//             >
//               {page.charAt(0).toUpperCase() + page.slice(1)}
//             </button>
//           ))}
//         </div>
//       </div>
//     </nav>
//   );
// };

// export default Navbar;
// // import React from "react";
// // import { Link } from "react-router-dom";
// // import "../styles/style.css"; // Ensure styles are applied

// // const Navbar = () => {
// //   return (
// //     <nav className="navbar navbar-expand-lg navbar-light bg-light">
// //       <div className="container">
// //         <Link className="navbar-brand" to="/">Celerity Technocrats</Link>
// //         <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
// //           <span className="navbar-toggler-icon"></span>
// //         </button>
// //         <div className="collapse navbar-collapse" id="navbarNav">
// //           <ul className="navbar-nav ms-auto">
// //             <li className="nav-item"><Link className="nav-link" to="/">Home</Link></li>
// //             <li className="nav-item"><Link className="nav-link" to="/about">About</Link></li>
// //             <li className="nav-item"><Link className="nav-link" to="/services">Services</Link></li>
// //             <li className="nav-item"><Link className="nav-link" to="/why">Why Us</Link></li>
// //             <li className="nav-item"><Link className="nav-link" to="/team">Team</Link></li>
// //             <li className="nav-item"><Link className="nav-link" to="/contact">Contact</Link></li>
// //           </ul>
// //         </div>
// //       </div>
// //     </nav>
// //   );
// // };

// // export default Navbar;
